export default "__VITE_ASSET__8orRwH30__$_?format=webp__"